<template>
  <div class="app-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>待处理订单</span>
      </div>
      
      <el-alert
        title="提示：此处显示所有已支付但未处理的订单"
        type="warning"
        :closable="false"
        style="margin-bottom: 20px"
      />

      <!-- 数据表格 -->
      <el-table v-loading="loading" :data="orderList">
        <el-table-column label="订单ID" align="center" prop="id" width="80" />
        <el-table-column label="订单号" align="center" prop="orderNo" width="180" />
        <el-table-column label="用户信息" align="center" prop="userName" width="120" />
        <el-table-column label="订单金额" align="center" prop="totalAmount" width="120" />
        <el-table-column label="支付时间" align="center" prop="payTime" width="180" />
        <el-table-column label="等待时长" align="center" prop="waitTime" width="120" />
        <el-table-column label="操作" align="center" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-check" @click="handleProcess(scope.row)">处理</el-button>
            <el-button size="mini" type="text" icon="el-icon-view" @click="handleView(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'PendingOrders',
  data() {
    return {
      loading: true,
      total: 0,
      orderList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      // TODO: 调用API获取待处理订单列表
      setTimeout(() => {
        this.orderList = []
        this.total = 0
        this.loading = false
      }, 500)
    },
    handleProcess(row) {
      this.$message.info('订单处理功能待实现')
    },
    handleView(row) {
      this.$message.info('查看详情功能待实现')
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}
</style>
